import { FAMILIES_PER_PAGE } from 'settings';

const pageNrToOffset = (pageNr: number) => (pageNr - 1) * FAMILIES_PER_PAGE;

export default pageNrToOffset;
